import { render, staticRenderFns } from "./FragmentedVerse.vue?vue&type=template&id=6b634a06&scoped=true&"
import script from "./FragmentedVerse.vue?vue&type=script&lang=js&"
export * from "./FragmentedVerse.vue?vue&type=script&lang=js&"
import style0 from "./FragmentedVerse.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FragmentedVerse.vue?vue&type=style&index=1&id=6b634a06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b634a06",
  null
  
)

export default component.exports